import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const PinIconAlt = (props: IconWrapperProps) => {
  return (
    <IconWrapper viewBox="0 0 24 24" {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill="#d95e16"
          d="M12 1a9 9 0 0 1 9 9c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 9-9m0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        />
      </svg>
    </IconWrapper>
  );
};
export default memo(PinIconAlt);
